import type {
  ConflictResponse,
  FileConflictType,
} from '../FileConflictDialog/FileConflictStore'
import { FileConflictQueue } from '../FileConflictDialog/FileConflictStore'

export type { ConflictResponse, FileConflictType }

export type UploadConflictQueue = {
  clear: () => void
  get hasMultiple(): boolean
  set hasMultiple(value: boolean)
  requestConflictAction: (
    filename: string,
    conflictType: FileConflictType,
  ) => Promise<ConflictResponse>
}

export function createUploadConflictQueue(): UploadConflictQueue {
  const queue = new FileConflictQueue()

  return {
    clear: () => queue.clear(),
    get hasMultiple() {
      return queue.hasMultiple
    },
    set hasMultiple(value: boolean) {
      queue.hasMultiple = value
    },
    requestConflictAction: (filename, conflictType) =>
      queue.requestConflictAction(filename, conflictType, 'UPLOAD'),
  }
}
